const name = 'ClearSequence';
const properties = {
    groups: ['animation'],
    schema: {},
};
/**
 * Clear and Reset all animations on some elements
 */
function animate(kit, elements, params = {}) {
    const tweens = elements.reduce((acc, element) => acc.concat(kit.engine.getTweensOf(element)), []);
    tweens.forEach((tween) => kit.engine.kill(tween));
    const sequence = kit.sequence(params);
    // We have to return an animation or sequence from an animation class, so adding an empty animation here
    // Actual clearing is handled by the system when platform sends a {clear: true} param
    sequence.add(kit.animate('BaseNone', elements, 0, 0, {}));
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=clearSequence.js.map